let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ahxSD"), load("7G6nu")]).then(() => parcelRequire('lini2'));